import { useStoreDispatch } from "../../store/Hooks";
import { navSliceActions } from "../../store/slices/NavSlice";
import EditorWrapper from "../ui/EditorWrapper"
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import Grid from "@mui/material/Grid";
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { TestFunctionProps, formatArgsForPostgresProcessing, getFunctionArgsFromTestString, getTestFunctions, returnTestsTSX, runTestFunction } from "../../helpers/TestingHelper";
import Test from "./Test";
import { runDatabaseFunction } from "../../helpers/HttpHelper";
import FastForwardIcon from '@mui/icons-material/FastForward';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';

const TestTools = () => {
    const dispatch = useStoreDispatch();
    const [individualFunctions, setIndividualFunctions] = useState<Array<any>>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        const setupTestFunctions = async () => {
            const testFunctionResults = await getTestFunctions();
            setIndividualFunctions(testFunctionResults);
        }
        setupTestFunctions()
    }, [])

    const individualFunctionsTSX = returnTestsTSX(individualFunctions)

    return (
        <EditorWrapper drawerAccordion={false} title="Testing Tools" inDrawer={true} cancel={async () => {
            dispatch(
                navSliceActions.closeRightDrawer({
                }),
            );
        }}>
            <div style={{ padding: "20px" }}>
                <Stack direction={"column"}>
                    <h3>Global Operations</h3>

                    <Grid container spacing={0}>
                        <Grid item xs={2}>
                            <Button
                                onClick={() => {
                                    runTestFunction('truncate_test', {})
                                    window.location.reload()
                                }}
                                style={{ marginTop: "15px", width:"50px"  }}
                                variant="outlined"
                                color="error">
                                <DeleteSweepIcon />
                            </Button>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>
                        <Grid item xs={8}>
                            <p>Clears out all data from the Postgres TEST schema. This is useful for resetting the database state for implementing new tests.</p>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                        <Grid item xs={2}>
                            <Button
                                onClick={() => {
                                    alert("This testing function not set up yet!")
                                }}
                                style={{ marginTop: "15px", width:"50px"  }}
                                variant="outlined"
                                color="error">
                                <FiberManualRecordIcon />
                            </Button>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>
                        <Grid item xs={8}>
                            <p>Record mode. When toggled ON,  this saves all of the actions taken while in record mode so that they can be replayed as an automated test. TODO: Add a verify button that does something somewhere to create an assert automatically to add to the test for regressibility</p>
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                        <Grid item xs={2}>
                            <Button
                                onClick={() => {
                                    runTestFunction('test_run_all', {})
                                }}
                                style={{ marginTop: "15px", width:"50px" }}
                                variant="outlined"
                                color="error">
                                <PlayCircleFilledIcon />
                                <DynamicFeedIcon style={{fontSize:"14pt", marginLeft:"-5px"}}/>
                            </Button>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>
                        <Grid item xs={8}>
                            <p>Run ALL tests. Runs the entire test suite of individual tests</p>
                        </Grid>
                    </Grid>
                          <br/>      
                    <Divider />
                    <h3>Individual Tests</h3>
                    <Grid container spacing={0}>
                        {individualFunctionsTSX}
                    </Grid>

                </Stack>
            </div>

        </EditorWrapper>)
}

export default TestTools